import React, { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";
import { STAGE } from "../../stage";
import { initDb } from "../../tools/conf";

/**
 * Ruban « STAGING » (façon bandeau d'Odoo.sh) : affiché uniquement quand le
 * bundle est construit pour le staging (STAGE === "stage", cf. deployStage.js).
 * La date de la copie de prod vient du document Firestore `config/staging`,
 * écrit par la neutralisation du rebuild (lisible sans compte), et à défaut de
 * /meta.json (`stagingSnapshot`, posé au build par scripts/rebuild-env.sh).
 * Non cliquable : ne gêne jamais l'interface.
 */
const snapshotFromMeta = () =>
  fetch(`/meta.json?t=${Date.now()}`, { cache: "no-store" })
    .then((response) => (response.ok ? response.json() : null))
    .then((meta) => (meta && meta.stagingSnapshot ? meta.stagingSnapshot : null))
    .catch(() => null);

const snapshotFromFirestore = () =>
  initDb()
    .collection("config")
    .doc("staging")
    .get()
    .then((snap) => {
      const value = snap.exists ? snap.data().snapshotAt : null;
      return value && typeof value.toDate === "function" ? value.toDate().toISOString() : value || null;
    })
    .catch(() => null);
const StagingRibbon = ({ t, i18n }) => {
  const [snapshot, setSnapshot] = useState(null);

  useEffect(() => {
    if (STAGE !== "stage") return undefined;
    let cancelled = false;
    snapshotFromFirestore()
      .then((value) => value || snapshotFromMeta())
      .then((value) => {
        if (!cancelled) setSnapshot(value);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (STAGE !== "stage") return null;

  const date = snapshot ? new Date(snapshot) : null;
  const formatted =
    date && !Number.isNaN(date.getTime())
      ? date.toLocaleString(i18n && i18n.language ? i18n.language : undefined, {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="staging-ribbon"
      style={{
        position: "fixed",
        left: "12px",
        bottom: "12px",
        zIndex: 9998,
        backgroundColor: "#e8b923",
        color: "#3a2e05",
        fontSize: "12px",
        fontWeight: 600,
        letterSpacing: "0.02em",
        padding: "6px 12px",
        borderRadius: "999px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
        pointerEvents: "none",
        maxWidth: "calc(100vw - 24px)",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      STAGING · {t("staging.ribbon.label")} ·{" "}
      {formatted ? t("staging.ribbon.snapshot", { date: formatted }) : t("staging.ribbon.noSnapshot")}
    </div>
  );
};

export default withNamespaces("translations")(StagingRibbon);
